import { render, staticRenderFns } from "./public-quiz-question-answer.html?vue&type=template&id=410ce0a4&scoped=true&"
import script from "./public-quiz-question-answer.js?vue&type=script&lang=js&"
export * from "./public-quiz-question-answer.js?vue&type=script&lang=js&"
import style0 from "./public-quiz-question-answer.scss?vue&type=style&index=0&id=410ce0a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410ce0a4",
  null
  
)

export default component.exports